<template>
    <div class='ph-query-home'>
        <div class="head-top"></div>
        <div class="query-one" @click="toLink">
            <p class="p-zh">成绩查询</p>
            <p class="p-en">Result inquiry</p>
            <p class="p-btn">立即查询  ></p>
        </div>
        <div class="query-two" @click="toLinks">
            <p class="p-zh">证书查询</p>
            <p class="p-en">Certificate query</p>
            <p class="p-btn">立即查询  ></p>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {

        }
    },
    mounted() {

    },
    created() {

    },
    methods: {
        toLink() { 
            window.open('http://www.clppx.org.cn/certifyQueryNew/2')
        },
        toLinks() { 
            window.open('http://www.clppx.org.cn/certifyQueryNew/1')
        },
    },
}
</script>
<style lang='scss' >
.ph-query-home{
    min-height: 100vh;
    background: #F7F7F7;
    .head-top{
        height: 150px;
        width: 100%;
        background: url('~@/assets/images/phone/bg.png') no-repeat center/cover;
    }
    .query-one{
        margin: 0 15px;
        padding: 20px 25px;
        margin-top: -26px;
        height: 130px;
        border-radius: 10px;
        color: #fff;
        box-sizing: border-box;
        background: url('~@/assets/images/phone/cj.png') no-repeat center/cover;
        box-shadow: 0px 3px 10px 0px rgba(0,0,0,0.16);
        .p-zh{
            margin-bottom: 8px;
            font-size: 18px;
            font-weight: 500;
        }
        .p-btn{
            margin-top: 28px;
            font-size: 12px;
        }
    }
    .query-two{
        margin: 0 15px;
        padding: 20px 25px;
        margin-top: 20px;
        height: 130px;
        border-radius: 10px;
        color: #fff;
        box-sizing: border-box;
        background: url('~@/assets/images/phone/zs.png') no-repeat center/cover;
        box-shadow: 0px 3px 10px 0px rgba(0,0,0,0.16);
        .p-zh{
            margin-bottom: 8px;
            font-size: 18px;
            font-weight: 500;
        }
        .p-btn{
            margin-top: 28px;
            font-size: 12px;
        }
    }
}
</style>
